import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { TurnstileObject } from "turnstile-types";
import { AppConfigService } from "./app-config.service";

declare global {
  interface Window {
    turnstile: TurnstileObject | null;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  constructor(
    private appConfigService: AppConfigService,
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  public async carregarScript() {
    return new Promise<TurnstileObject>((resolve, reject) => {
      if (window["turnstile"]) {
        resolve(window["turnstile"]);

        return;
      }

      const challengerEl = this.document.getElementById('challenger-script');

      if (challengerEl) {
        this.document.head.removeChild(challengerEl);
      }

      // Incorporando o script do turnstile
      const script = this.document.createElement("script");

      script.id = "challenger-script";
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;

      this.document.head.appendChild(script);

      script.addEventListener("load", () => {
        resolve(window["turnstile"])
      });

      script.addEventListener("error", () => {
        reject(new Error("Falha ao carregar o script de verificação de segurança. Atualize a página e tente novamente."))
      });
    });
  }

  public buscarChaveCliente(): string | null {
    return this.appConfigService.getCaptchaSiteKey()
  }

  public captchaHabilitado() {
    const key = this.buscarChaveCliente();

    return key !== undefined && key !== null && key.trim() !== '';
  }
}
